import { render } from "./index.vue?vue&type=template&id=260d0649&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=260d0649&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260d0649"],['__file',"src/views/MyAccount/MyCard/AddCard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "260d0649"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('260d0649', __exports__)) {
    console.log('reload')
    api.reload('260d0649', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=260d0649&scoped=true", () => {
    console.log('re-render')
    api.rerender('260d0649', render)
  })

}


export default __exports__